import { RootState } from 'src/ui/app/store';
import { DialogType } from 'src/ui/features/ui';

export const isDialogOpenSelector = (dialog?: DialogType) => (
  state: RootState
) => (dialog ? state.ui.dialog?.type === dialog : Boolean(state.ui.dialog));
